<div class="title-container">
    <div>
        <h1 class="title-default">Detalhe do CT-e</h1>
        <p>Dados do Conhecimento de Transporte Eletrônico</p>
    </div>
    <div class="action-buttons-container">
        <a mat-button class="btn-secondary" color="secundary" (click)="voltar()">
            <span class="material-symbols-outlined">arrow_back</span> Voltar
        </a>
    </div>
</div>

<section class="summary-section">
    <div class="summary-card">
        <span class="label">Valor do frete</span>
        <span class="value">{{ notaDetalhe.resumo.valorTotal | currency:'BRL' }}</span>
    </div>
    <div class="summary-card">
        <span class="label">Data de emissão</span>
        <span class="value">{{ notaDetalhe.resumo.dataEmissao | date:'dd/MM/yyyy' }}</span>
    </div>
    <div class="summary-card">
        <span class="label">Status</span>
        <span class="value status-valid"
            [ngClass]="{'status-valid':!_isCancelamento, 'status-cancelado':_isCancelamento}">
            {{ obterDescricaoSituacaoDocumento() }}
        </span>
    </div>
</section>

<h2 class="section-title">Dados do Transporte</h2>
<section class="info-grid">
    <div class="info-item wide">
        <span class="label">Chave do CT-e</span>
        <span class="value">{{ notaDetalhe.informacoesDocumento.chave }}</span>
    </div>
    <div class="info-item">
        <span class="label">Natureza da Operação</span>
        <span class="value">{{ notaDetalhe.dadosCTe.naturezaOperacao }}</span>
    </div>
    <div class="info-item">
        <span class="label">Modal</span>
        <span class="value">{{ notaDetalhe.dadosCTe.modal }}</span>
    </div>
    <div class="info-item">
        <span class="label">RNTRC</span>
        <span class="value">{{ notaDetalhe.dadosCTe.rntrc || 'Não informado' }}</span>
    </div>
    <div class="info-item">
        <span class="label">Produto Predominante</span>
        <span class="value">{{ notaDetalhe.dadosCTe.produtoPredominante }}</span>
    </div>
    <div class="info-item">
        <span class="label">Valor da Carga</span>
        <span class="value">{{ notaDetalhe.dadosCTe.valorCarga | currency:'BRL' }}</span>
    </div>
</section>

@if(notaDetalhe.dadosCTe.quantidades && notaDetalhe.dadosCTe.quantidades.length > 0) {
<h2 class="section-title">Detalhamento da Carga</h2>
<table mat-table [dataSource]="dataSourceCarga">
    <ng-container matColumnDef="unidade">
        <th mat-header-cell *matHeaderCellDef> Unidade </th>
        <td mat-cell *matCellDef="let element"> {{element.unidade}} </td>
    </ng-container>
    <ng-container matColumnDef="tipoMedida">
        <th mat-header-cell *matHeaderCellDef> Tipo de Medida </th>
        <td mat-cell *matCellDef="let element"> {{element.tipoMedida}} </td>
    </ng-container>
    <ng-container matColumnDef="quantidade">
        <th mat-header-cell *matHeaderCellDef> Quantidade </th>
        <td mat-cell *matCellDef="let element"> {{element.quantidade}} </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumnsCarga"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumnsCarga;"></tr>
</table>
}

@if(notaDetalhe.tributosDeclarados) {
<h2 class="section-title">Impostos e Tributos</h2>
<section class="info-grid tributos">
    <div class="info-item">
        <span class="label">Base de cálculo ICMS</span>
        <span class="value">{{ notaDetalhe.tributosDeclarados.baseDeCalculoIcms | currency:'BRL' }}</span>
    </div>
    <div class="info-item">
        <span class="label">Valor do ICMS</span>
        <span class="value">{{ notaDetalhe.tributosDeclarados.icms | currency:'BRL' }}</span>
    </div>
    <div class="info-item">
        <span class="label">PIS</span>
        <span class="value">{{ notaDetalhe.tributosDeclarados.pis | currency:'BRL' }}</span>
    </div>
    <div class="info-item">
        <span class="label">COFINS</span>
        <span class="value">{{ notaDetalhe.tributosDeclarados.cofins | currency:'BRL' }}</span>
    </div>
    <div class="info-item total-tributos">
        <span class="label">Total de Tributos</span>
        <span class="value">{{ notaDetalhe.tributosDeclarados.totalDeTributosDeclarados | currency:'BRL' }}</span>
    </div>
</section>
}

<h2 class="section-title">Participantes do Transporte</h2>
<div class="cte-participants-grid">
    @if(notaDetalhe.participantes.tomador) {
    <div class="participant-card highlight">
        <span class="participant-role">Tomador (Pagador) - {{ notaDetalhe.participantes.tomador.papel }}</span>
        <p><strong>{{ notaDetalhe.participantes.tomador.nome }}</strong></p>
        <p>{{ notaDetalhe.participantes.tomador.cpfCnpj }}</p>
        <p>{{ notaDetalhe.participantes.tomador.cidade }} - {{ notaDetalhe.participantes.tomador.uf }}</p>
    </div>
    }
    @if(notaDetalhe.participantes.emitente) {
    <div class="participant-card">
        <span class="participant-role">Prestador (Emitente)</span>
        <p>{{ notaDetalhe.participantes.emitente.nome }}</p>
        <p>{{ notaDetalhe.participantes.emitente.cpfCnpj }}</p>
    </div>
    }
    @if(notaDetalhe.participantes.remetente) {
    <div class="participant-card">
        <span class="participant-role">Remetente</span>
        <p>{{ notaDetalhe.participantes.remetente.nome }}</p>
        <p>{{ notaDetalhe.participantes.remetente.cpfCnpj }}</p>
    </div>
    }
    @if(notaDetalhe.participantes.destinatario) {
    <div class="participant-card">
        <span class="participant-role">Destinatário</span>
        <p>{{ notaDetalhe.participantes.destinatario.nome }}</p>
        <p>{{ notaDetalhe.participantes.destinatario.cpfCnpj }}</p>
    </div>
    }
</div>

@if(notaDetalhe.dadosCTe.chavesNFeRelacionadas?.length) {
<h2 class="section-title">Documentos Relacionados (NF-es)</h2>
<div class="keys-container">
    <span class="key-badge">
        <span class="material-symbols-outlined">description</span>
        {{ notaDetalhe.dadosCTe.chavesNFeRelacionadas }}
    </span>
</div>
}

@if(notaDetalhe.dadosCTe.observacoes) {
<h2 class="section-title">Observações</h2>
<div class="obs-box">
    <p>{{ notaDetalhe.dadosCTe.observacoes }}</p>
</div>
}
